import { render } from "./alunos.vue?vue&type=template&id=e9a764e2"
import script from "./alunos.vue?vue&type=script&lang=js"
export * from "./alunos.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__